import { ListItem } from '@material-ui/core'
import { LanguageFlag } from 'components/facets/LanguageFlag'
import { useUser } from 'components/providers/UserProvider'
import { currencySymbol } from 'lib/utils'
import { CardmarketArticle, flagCode, REPUTATIONS, SellerLevel, SELLER_LEVELS } from 'shared'
import {
  FIRST_EDITION_ICON,
  FOIL_ICON,
  PLAYSET_ICON,
  REVERSE_HOLO_ICON,
  SIGNED_ICON,
} from 'utils/constants'
import { Condition } from './Condition'
import { CustomTooltip } from './CustomTooltip'
import { AllSellersIcon, PowerSellerSellersIcon, ProfessionalSellersIcon } from './Icons'

export const ArticleLine = ({ article }: { article: CardmarketArticle }): JSX.Element => {
  const {
    quantity,
    isFoil,
    isPlayset,
    isFirstEd,
    isSigned,
    condition,
    isReverseHolo,
    idLanguage,
    seller,
  } = article

  const { user } = useUser()

  const price = article[user?.currency === 'GBP' ? 'priceGBP' : 'price']

  const SellerIcon = {
    [SellerLevel.Private]: AllSellersIcon,
    [SellerLevel.Professional]: ProfessionalSellersIcon,
    [SellerLevel.Powerseller]: PowerSellerSellersIcon,
  }[seller.isCommercial]

  return (
    <ListItem>
      {quantity}x <Condition id="ArticleLine-condition" value={condition} />{' '}
      <LanguageFlag
        style={{ padding: '0px 5px' }}
        height="12"
        code={flagCode(idLanguage) || 'gg'}
      />{' '}
      {isFoil && <img alt="foil" height="18px" src={FOIL_ICON} />}{' '}
      {isReverseHolo && <img alt="reverseholo" height="18px" src={REVERSE_HOLO_ICON} />}{' '}
      {isPlayset && <img alt="playset" height="18px" src={PLAYSET_ICON} />}
      {isFirstEd && <img alt="firstEd" height="18px" src={FIRST_EDITION_ICON} />}
      {isSigned && <img alt="signed" height="18px" src={SIGNED_ICON} />}
      {` | ${seller.username}(${seller.sellCount}) | ${seller.country} | 
        `}
      <CustomTooltip title={`${SELLER_LEVELS[Number(seller.isCommercial)]}`}>
        <SellerIcon />
      </CustomTooltip>
      {`
      | ${REPUTATIONS[Number(seller.reputation)]} | `}
      {price}
      {currencySymbol(user?.currency)}
    </ListItem>
  )
}
